import { render, staticRenderFns } from "./EdsDropArea.vue?vue&type=template&id=5d723b02&"
import script from "./EdsDropArea.vue?vue&type=script&lang=js&"
export * from "./EdsDropArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports